export default "__VITE_ASSET__DXRkj0Sv__"